<template>
  <div>
    <el-col :span="12">
      <div class="search">
        <el-col :span="20">
        <el-input v-model="formData.keyword" placeholder="请输入内容"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="searchBids()">搜索</el-button>
      </el-col>
      </div>
      
    </el-col>
    <el-table :data="tableData" style="width: 100%" height="250" border>
      <el-table-column fixed prop="user_name" label="用户名" width="90" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="bid_title" label="招标标题" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="bid_content" label="招标正文" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="200" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="address" label="收货地址" width="300" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="end_time" label="截止时间" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="deliver_time" label="交货时间" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="pay" label="支付方式" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="delivery" label="交货方式" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="transport" label="货运方式" width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看报价情况</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="formData.page"
      :page-sizes="[20,60,100,140]"
      :page-size="formData.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
    ></el-pagination>

    <el-dialog title="提示" :visible.sync="dialogVisibleTrans" width="70%">
      <offer :bidId="id"></offer>
    </el-dialog>
  </div>
</template>

<script>
import offer from '@/views/defaultPage/Offer.vue'
export default {
  name: "BidManage",
  components: {
        'offer': offer  //将别名demo 变成 组件 Demo
      },
  data() {
    return {
      formData: {
        keyword: "",
        startDate: "",
        endDate: "",
        page: 1,
        limit: 20
      },
      count: 0,
      tableData: [],
      dialogVisibleTrans:false,
      id:""
    };
  },
  methods: {
    searchBids() {
      let formData = this.formData;
      this.$http
        .post("/v2/validate/SearchMyBid", { formData })
        .then(res => {
          console.log(res.data);
          this.tableData = res.data;
          this.count = res.count;
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSizeChange(val) {
      this.formData.limit = val;
      this.searchBids();
    },
    handleCurrentChange(val) {
      this.formData.page = val;
      this.searchBids();
    },
    handleEdit(index, row){
      console.log(index , row)
      this.id = row.id
      console.log(this.id)
      this.dialogVisibleTrans = true
    }
  },
  created() {
    this.searchBids();
  }
};
</script>

<style scoped>
.pagination{text-align: center;margin-bottom: 25px;}
.search{text-align: center }
.search .el-col {margin-bottom: 15px}
</style>